module.exports = __webpack_public_path__ + "0c72f1a3861b39cca93bec3e58afd5f4.svg";